<template>
  <div class="row border rounded border-primary mt-1">
    <div class="col">
      <div class="dropdown">
        <i
          class="bi bi-chevron-down"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          @click="fetchLivePlayerID()"
        ></i>
        <ul class="dropdown-menu">
          <li
            class="dropdown-item"
            v-for="p in sorted_players"
            :key="p"
            @click="setAsLivePlayer(p.player_id)"
          >
            <PlayerName :player_id="p.player_id"></PlayerName>
            <SoldTickmark :player_id="p.player_id"></SoldTickmark>
            <i
              class="bi bi-circle-fill float-end text-warning"
              v-if="live_player_id == p.player_id"
            ></i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, computed, ref, onBeforeMount } from "vue";
import { useStore } from "@/store/index";
import supabase from "@/supabase/config";
import PlayerName from "./PlayerName.vue";
import SoldTickmark from "./SoldTickmark.vue";
const props = defineProps(["pool_id"]);
const store = useStore();
const players_list = ref([]);
const live_player_id = ref("");
const players_status = ref([]);
onBeforeMount(() => {
  fetchPlayersList();
  fetchLivePlayerID();
});
const fetchLivePlayerID = async () => {
  setTimeout(() => {});
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")
    .eq("id", props.pool_id);
  live_player_id.value = pools[0].live_player_pointer;
  fetchLatestSaleStatus();
};
const fetchLatestSaleStatus = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("pool_id", props.pool_id);
  players_status.value = players;
};
const fetchPlayersList = async () => {
  let { data: pool_list, error } = await supabase
    .from("pool_list")
    .select("*")
    .eq("pool_id", props.pool_id);
  players_list.value = pool_list;
};
const sorted_players = computed(() => {
  var arr = [];
  players_list.value.forEach((l) => {
    arr.push(l);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => a.sort - b.sort);
  return sorted_arr;
});
const setAsLivePlayer = async (id) => {
  clearExistingLivePlayer(); //this is done to trigger a reload of the LivePlayer component
  setTimeout(() => {
    setLivePlayer(id);
  }, 200);
  setBiddingOpenToFalse();
};
const clearExistingLivePlayer = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ live_player_id: null })
    .eq("id", store.live_auction)
    .select();
};
const setLivePlayer = async (id) => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ live_player_id: id })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    updatePlayerIDinPoolTable(id);
  }
};
const updatePlayerIDinPoolTable = async (id) => {
  const { data, error } = await supabase
    .from("pools")
    .update({ live_player_pointer: id })
    .eq("id", props.pool_id)
    .select();
};
const setBiddingOpenToFalse = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ bidding_open: false })
    .eq("id", store.live_auction)
    .select();
};
</script>
<style scoped>
.dropdown-item {
  padding: 5px;
  font-size: 12px;
}
</style>
